import React, { useMemo } from "react";

const useLocalPagination = (data) => {
  const [currentPage, setCurrentPage] = React.useState(1);
  const [pageSize, setPageSize] = React.useState(10);
  const [totalPages, setTotalPages] = React.useState(1);
  const [totalRecords, setTotalRecords] = React.useState(0);
  const [paginatedData, setPaginatedData] = React.useState([]);
  const previousPage = currentPage > 1 ? currentPage - 1 : null;
  const nextPage = currentPage < totalPages ? currentPage + 1 : null;

  const currentPageIndexes = useMemo(() => {
    if (currentPage === totalPages) {
      return {
        start: currentPage ? (currentPage - 1) * 10 + 1 : 0,
        end: totalRecords ?? 0,
      };
    } else {
      return {
        start: currentPage ? (currentPage - 1) * 10 + 1 : 0,
        end: currentPage ? currentPage * 10 : 0,
      };
    }
  }, [currentPage, totalRecords]);

  const slicePageData = () => {
    if (Array.isArray(data) && data) {
      const startIndex = (currentPage - 1) * pageSize;
      const endIndex = startIndex + pageSize;
      setPaginatedData(data.slice(startIndex, endIndex));
    }
  };

  React.useEffect(() => {
    if (Array.isArray(data)) {
      setTotalRecords(data.length);
      setTotalPages(Math.ceil(data.length / pageSize));
      if (currentPage === 1) {
        slicePageData();
      }
      setCurrentPage(1);
    }
  }, [data, pageSize]);

  React.useEffect(() => {
    slicePageData();
  }, [currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setCurrentPage(1);
  };

  const handleFirstPage = () => {
    if (currentPage > 1) {
      setCurrentPage(1);
    }
  };

  const handleLastPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(totalPages);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return {
    currentPage,
    pageSize,
    totalPages,
    totalRecords,
    paginatedData,
    currentPageIndexes,
    handlePageChange,
    handlePageSizeChange,
    handleNextPage,
    handlePreviousPage,
    handleFirstPage,
    handleLastPage,
    slicePageData,
    setPaginatedData,
    setTotalPages,
    setTotalRecords,
    setCurrentPage,
    setPageSize,
    previousPage,
    nextPage,
  };
};

export default useLocalPagination;
